import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import apiService from '../../services/api';
import { toast } from 'react-toastify';
import { FloorImageWrapper } from '../../styles/FloorImageWrapper';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';

const FloorImage: React.FC = () => {
  const [image, setImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [fileType, setFileType] = useState<'image' | 'pdf' | 'doc' | 'unknown'>(
    'unknown'
  );

  const getFileName = (url: string) => {
    try {
      return decodeURIComponent(url.split('/').pop() || 'File');
    } catch {
      return 'File';
    }
  };

  const FileCard = ({
    icon,
    title,
    actionLabel,
    fileUrl,
  }: {
    icon: React.ReactNode;
    title: string;
    actionLabel: string;
    fileUrl: string;
  }) => (
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        padding: 4,
        maxWidth: 420,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        backgroundColor: '#fafafa',
      }}
    >
      {icon}

      <Typography
        sx={{
          fontWeight: 500,
          textAlign: 'center',
          wordBreak: 'break-all',
        }}
      >
        {title}
      </Typography>

      <Button
        variant="contained"
        href={fileUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {actionLabel}
      </Button>
    </Box>
  );

  // const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {

  //   const file = e.target.files?.[0];
  //   if (!file) return;

  //   // Show preview immediately
  //   const previewURL = URL.createObjectURL(file);
  //   setImage(previewURL);
  //   setSaving(true);

  //   try {
  //     const formData = new FormData();
  //     formData.append('file', file);

  //     const response = await apiService.uploadFloorImage(formData);

  //     toast.success(response.message || 'Image saved successfully');
  //   } catch (err: any) {
  //     const errorMsg =
  //       err?.response?.data?.message ||
  //       err?.message ||
  //       'Something went wrong. Please try again.';

  //     toast.error(errorMsg);
  //   } finally {
  //     setSaving(false);
  //   }
  // };
  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.type.startsWith('image/')) setFileType('image');
    else if (file.type === 'application/pdf') setFileType('pdf');
    else if (
      file.type ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      file.type === 'application/msword'
    )
      setFileType('doc');
    else setFileType('unknown');

    const previewURL = URL.createObjectURL(file);
    setImage(previewURL);
    setSaving(true);

    try {
      const formData = new FormData();
      formData.append('file', file);
      await apiService.uploadFloorImage(formData);
      toast.success('File saved successfully');
    } catch (err: any) {
      toast.error('Upload failed');
    } finally {
      setSaving(false);
    }
  };

  const fetchFloorPlan = async () => {
    setLoading(true);
    try {
      const response = await apiService.getVenues();

      // if (response?.floorImg?.imageUrl) {
      //   setImage(response?.floorImg?.imageUrl);
      // }
      if (response?.floorImg?.imageUrl) {
        const url = response.floorImg.imageUrl;
        setImage(url);

        const ext = url.split('.').pop()?.toLowerCase();

        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext!))
          setFileType('image');
        else if (ext === 'pdf') setFileType('pdf');
        else if (['doc', 'docx'].includes(ext!)) setFileType('doc');
        else setFileType('unknown');
      }
    } catch (err: any) {
      const apiError =
        err?.response?.data?.message ||
        err?.message ||
        'Something went wrong. Please try again.';
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFloorPlan();
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* PAGE LOADER */}
      {loading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress size={45} />
        </Box>
      )}

      {!loading && (
        <>
          {/* HEADER */}
          <FloorImageWrapper>
            <Box className="header">
              <Typography sx={{ fontSize: 25, fontWeight: 600 }}>
                {' '}
                Floor Plan{' '}
              </Typography>

              <Button variant="contained" component="label" disabled={saving}>
                {saving
                  ? image
                    ? 'Editing...'
                    : 'Uploading...'
                  : image
                    ? 'Edit'
                    : 'Upload'}

                {/* Hide input while saving */}
                {!saving && (
                  // <input
                  //   type="file"
                  //   hidden
                  //   accept="image/*"
                  //   onChange={handleImageChange}
                  // />
                  <input
                    type="file"
                    hidden
                    accept="image/*,.pdf,.doc,.docx"
                    onChange={handleImageChange}
                  />
                )}
              </Button>
            </Box>

            {/* IMAGE AREA */}
            {/* <Box className="image-area">
              {!image ? (
                <Typography>No floor image uploaded</Typography>
              ) : saving ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <CircularProgress />
                  <Typography>Saving image...</Typography>
                </Box>
              ) : (
                <img src={image} alt="Floor Plan" className="floor-image" />
              )}
            </Box> */}
            {/* ............................................... */}
            {/* <Box className="image-area">
              {!image ? (
                <Typography>No floor file uploaded</Typography>
              ) : saving ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <CircularProgress />
                  <Typography>Saving file...</Typography>
                </Box>
              ) : fileType === 'image' ? (
                <img src={image} alt="Floor Plan" className="floor-image" />
              ) : fileType === 'pdf' ? (
                <>
                  <Typography>PDF Preview</Typography>
                  <Button
                    variant="outlined"
                    href={image}
                    target="_blank"
                  >
                    Open PDF
                  </Button>
                </>
              ) : fileType === 'doc' ? (
                <>
                  <Typography>Document uploaded</Typography>
                  <Button
                    variant="outlined"
                    href={image}
                    target="_blank"
                  >
                    Download / Open Document
                  </Button>
                </>
              ) : (
                <Typography>Unsupported file type</Typography>
              )}
            </Box> */}
            <Box className="image-area">
              {!image ? (
                <Typography>No floor file uploaded</Typography>
              ) : saving ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <CircularProgress />
                  <Typography>Saving file...</Typography>
                </Box>
              ) : fileType === 'image' ? (
                <img src={image} alt="Floor Plan" className="floor-image" />
              ) : fileType === 'pdf' ? (
                <FileCard
                  icon={
                    <PictureAsPdfIcon sx={{ fontSize: 60, color: '#d32f2f' }} />
                  }
                  title={getFileName(image)}
                  actionLabel="Open PDF"
                  fileUrl={image}
                />
              ) : fileType === 'doc' ? (
                <FileCard
                  icon={
                    <DescriptionIcon sx={{ fontSize: 60, color: '#1976d2' }} />
                  }
                  title={getFileName(image)}
                  actionLabel="Open Document"
                  fileUrl={image}
                />
              ) : (
                <Typography>Unsupported file type</Typography>
              )}
            </Box>
          </FloorImageWrapper>
        </>
      )}
    </Box>
  );
};

export default FloorImage;
